// src/main.tsx — SCE Issues
// Point d'entrée React
//
// La bascule de rôle (Lot 7) est montée dans App.tsx, sous l'AuthProvider :
// elle a besoin du compte MSAL réel pour décider qui y a droit.

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { appliquerReglageMemorise } from './features/couleurs-metier/appliquer'
import { appliquerRolesMemorises } from './features/roles/chargeur'
import './styles/globals.css'

// Couleurs métier (Lot 8) connues au dernier passage, posées AVANT le premier
// rendu : sans quoi l'écran s'afficherait aux couleurs d'origine le temps que
// SharePoint réponde.
appliquerReglageMemorise()
// Rôles du panneau d'administration (22/10) connus au dernier passage : droits,
// appareils partagés et comptes secondaires reconnus dès le premier écran.
appliquerRolesMemorises()

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Élément #root introuvable dans index.html')
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
